import { render, staticRenderFns } from "./AButton.vue?vue&type=template&id=663886a0&scoped=true"
import script from "./AButton.vue?vue&type=script&lang=js"
export * from "./AButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663886a0",
  null
  
)

export default component.exports